import AxiosConfig from "./AxiosConfig";

const searchUsers = async ( value, entrepriseId ) => {
    if (!entrepriseId) entrepriseId = "all";
    const response = await AxiosConfig.get(`/users/search?q=${value}&entreprise=${entrepriseId}`); //  await fetch(`/search/users?q=${value}`);
    return response.data;
}

const searchReferents = async (value, entrepriseId) => {
    const response = await AxiosConfig.get(`/users/search_referent?q=${value}&entreprise=${entrepriseId}`);
    return response.data;
}

const searchCoachs = async (value, act = null) => {
    const url = `/users/search_coach?q=${value}`;
    const response = await AxiosConfig.get(url + (act ? `&act=${act}` : ""));
    return response.data;
}

const searchEntreprises = async (value) => {
    const response = await AxiosConfig.get(`/entreprises/search?q=${value}`);
    return response.data;
}

const searchGlobal = async (value) => {
    // const response = await AxiosConfig.get(`/admin/search_global?q=${value}`);
    const response = await AxiosConfig.get(`/search/global?q=${value}`);

    return response.data;
}

export { searchUsers, searchReferents, searchCoachs, searchEntreprises, searchGlobal };